module.exports = __webpack_public_path__ + "static/media/linode.ca5ddf57.svg";